var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      ref: "item",
      staticClass: "card history accordion-item",
      attrs: { id: _vm.itemId },
    },
    [
      _vm.hasHeader
        ? _c(
            "div",
            {
              class: [
                "card-header",
                "accordion-header",
                { "cursor-pointer": _vm.isCollapsible },
              ],
              attrs: { id: _vm.headingId },
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.toggle.apply(null, arguments)
                },
              },
            },
            [
              _c("div", { staticClass: "row align-items-center no-gutters" }, [
                _c("div", { staticClass: "col" }, [_vm._t("header")], 2),
                _vm._v(" "),
                _vm.showRemoveButton || _vm.showArrow
                  ? _c("div", { staticClass: "col-auto pl-3" }, [
                      _vm.showRemoveButton
                        ? _c(
                            "span",
                            {
                              staticClass: "icon",
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  return _vm.onRemove.apply(null, arguments)
                                },
                              },
                            },
                            [_c("i", { staticClass: "fas fa-xmark" })]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.showArrow
                        ? _c("span", { staticClass: "icon" }, [
                            _c("i", {
                              staticClass: "fas",
                              class: [
                                _vm.show ? "fa-angle-up" : "fa-angle-down",
                              ],
                            }),
                          ])
                        : _vm._e(),
                    ])
                  : _vm._e(),
              ]),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          ref: "content",
          class: [
            "accordion-content",
            { show: _vm.show, collapsing: _vm.collapsing },
          ],
          style: _vm.heightStyle,
          attrs: { id: _vm.collapseId },
        },
        [
          _c(
            "div",
            {
              staticClass: "card-body accordion-content-inner",
              class: _vm.classBody,
            },
            [_vm._t("body")],
            2
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }